import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useQuery } from "../../../../hooks/common";
import Header from "../../../policy/fragments/heading";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useParams } from "react-router-dom";
import { useStore } from "react-redux";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import { fetchGetMessage } from "../../../../../api";

const NewPage = props =>{
    const [reminderMessage, setReminderMessage] = useState(null);
    const query = useQuery();

    useEffect(async () =>{
        let response = await fetchGetMessage("M1618");
        // console.log('NewPageresponse', response)
        if(response?.code === 200 && response.result){
            const { message } = response.result;
            let str = message;
            let reg = /<span\s*id='email'>[\s\S]*<\/span>/g;
            let reg2 = /#email#/;
            if(query?.pointsForCash){
                str = str.replace(reg,`<span id='email'>100 points = $${query.pointsForCash} USD.</span>`)
            }
            
            if(query?.email){
                str = str.replace(reg2,query.email)
            }
            setReminderMessage(str);
        }
    }, []);
    
    return <div className={cls.NewPage}>
        {
            reminderMessage && <div dangerouslySetInnerHTML={{__html:reminderMessage }}></div>
        }
        

        <div className={cls.BtnContainer}>
            <a href="/"><FormattedMessage id="shop_now" defaultMessage="Shop Now" /></a>
            <a href="/user/credits"><FormattedMessage id="get_more_points" defaultMessage="Get More points" /></a>
        </div>
    </div>
}

const OldPage = props =>{
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const global = useSelector(state=>state.global);
    const { config } = global;
    const { customer } = pageCustomer;

    return <div className={cls.OldPage}>
        <Header 
            centerSlot={'Login Protection'}
        />

        <div className={cls.LoginPro}>
            <Iconfont className={cls.Icon}>&#xe73b;</Iconfont>
            <p><strong>Congratulations!</strong></p>
            <p>Your account has been successfully verified</p>
            <p className={cls.Greyfont}>Your registered email address is:{customer?.email}You have received <span>100 {config?.name} credits for verfifying for the first time</span></p>
        </div>

        <div className={cls.BtnContainer}>
            <a href="/"><FormattedMessage id="shop_now" defaultMessage="Shop Now" /></a>
            <a href="/user"><FormattedMessage id="my_account" defaultMessage="My Account" /></a>
        </div>
    </div>
}

const ConfirmSuccess = props =>{
    useStyles(cls);
    const query = useQuery();
    const store = useStore()
    const params = useParams()

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await ConfirmSuccess.fetchData(store, params, query)
		}
    }, []);

    return <div className={cls.ConfirmSuccess}>
        {
            query?.pointsForCash ? <NewPage /> : <OldPage />
        }
    </div>
}

ConfirmSuccess.fetchData = async (store, params, search, headers) => {
}

export default ConfirmSuccess;